import { render } from "./createAccount.vue?vue&type=template&id=5835fb2b&scoped=true"
import script from "./createAccount.vue?vue&type=script&lang=js"
export * from "./createAccount.vue?vue&type=script&lang=js"

import "./createAccount.vue?vue&type=style&index=0&id=5835fb2b&lang=less&scoped=true"

import exportComponent from "D:\\New Git\\tl-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5835fb2b"]])

export default __exports__